import { IconButton, type IconButtonProps, type Theme } from "@mui/material";

interface MapControlIconButtonProps extends IconButtonProps {}

const MapControlIconButton: React.FC<MapControlIconButtonProps> = ({
  children,
  size = "medium",
  sx,
  ...props
}) => {
  return (
    <IconButton
      size={size}
      sx={{
        backgroundColor: (theme: Theme) => theme.palette.common.white,
        color: (theme: Theme) => theme.palette.common.black,
        "&:hover": {
          backgroundColor: (theme: Theme) => theme.palette.grey[200],
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </IconButton>
  );
};

export default MapControlIconButton;
